var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendFundsScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.215,
    height: 110,
    viewBox: "0 0 127.215 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 62.995,
    height: 60.475,
    fill: "#f07900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intro_3",
    "data-name": "Intro 3",
    transform: "translate(-22.693 -241.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M110.982,143.963c29.666,3.94,60.374,15.981,75.244,0s10.794-31.1-3-50.063S177.25,57.959,143.345,45.63s-57.669,8.853-70.98,34.933S81.316,140.023,110.982,143.963Z",
    transform: "translate(-45.728 199.947)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(55.045 267.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M178.819,30.57a4.41,4.41,0,1,1-4.41-4.41,4.41,4.41,0,0,1,4.41,4.41",
    transform: "translate(-127.164 -19.568)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M178.819,183.25a4.41,4.41,0,1,1-4.41-4.41,4.41,4.41,0,0,1,4.41,4.41",
    transform: "translate(-127.164 -133.776)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M6.966,111.174,5.8,111.4,0,112.512v13.867H17.067c3.66,0,6.492-4.057,8.365-6.742.39-.559.758-1.087,1.1-1.53a101.433,101.433,0,0,1,8.591-9.157c.358-.352.7-.685,1.015-1,.3-.295.605-.587.9-.869,3.178-3.03,3.251-3.648,2.185-4.973-.76-.944-1.275-.944-1.522-.944a8.3,8.3,0,0,0-3.113,1.177c-.261.136-.517.27-.767.395-.784.393-4.756,2.962-7.326,4.661l-5.169,3.416,1.317-6.054,1.2-5.518.025-.114.035-.111c.525-1.658,2.254-2.812,4.772-3.87a.506.506,0,0,0,.312-.467l-.016-6.074a.5.5,0,0,0-.66-.478c-4.771,1.561-9.352,3.161-10.759,3.829-1.283,2.21-6.653,12-10.018,18.172Z",
    transform: "translate(0 -65.904)",
    fill: "#746f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M125.5,0a.5.5,0,0,0-.5.5v24.2l.017,6.144-.017.006v4.421c.529-.324.955-.574,1.2-.7.409-.205.835-.433,1.272-.657V2.469h26.56V58.006h-26.56V47.74c-.827.834-1.665,1.7-2.469,2.561v9.67a.5.5,0,0,0,.5.5h30.49a.5.5,0,0,0,.5-.5V.5a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-93.503)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M154.059,141.939a10.1,10.1,0,0,0,.879,1.149,3.729,3.729,0,0,0-.474-.708,4.185,4.185,0,0,0-.4-.441",
    transform: "translate(-115.239 -106.173)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M157.579,80a10.088,10.088,0,0,0-9.763,12.592c.073,0,.146-.008.22-.008a4.354,4.354,0,0,1,3.485,1.884,4.073,4.073,0,0,1,.909,4.275A10.079,10.079,0,1,0,157.579,80",
    transform: "translate(-110.333 -59.842)",
    fill: "#f07900"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFundsScreen);
export default __webpack_public_path__ + "static/media/send-funds-screen.b8466f96f947434e7767b0b31028b8f6.svg";
export { ForwardRef as ReactComponent };